import React from 'react'

export default function ({ label, children, className, ...rest }) {
  return (
    <div className='flex flex-col gap-1'>
      <label className='has-text-weight-semibold has-text-info'>{label}</label>
      <div className={`is-family-monospace ${className || ''}`} {...rest}>
        {children}
      </div>
    </div>
  )
}
